// extracted by mini-css-extract-plugin
export default {"accountSetup":"SignUpMobile_accountSetup__nR85A","accountSetupMainSection":"SignUpMobile_accountSetupMainSection__+AaP0"};